import { ReactNode } from 'react';
import { useSafeSelector } from '../../hooks/useSafeSelector';
import { Loader } from '../Loader';
import styles from './button.module.scss';
interface CustomStyleType {
  backgroundColor?: string;
  disabled?: any;
  [key: string]: any;
}
export interface ButtonProps {
  label?: string | ReactNode;
  id: string;
  color?: string;
  type?: 'submit' | 'button';
  icon?: string;
  loading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  fullWidth?: boolean;
  disabled?: boolean;
  customStyle?: CustomStyleType;
  className?: string;
}

export function Button(props: ButtonProps) {
  const {
    loading,
    disabled,
    label,
    id,
    color,
    icon,
    onClick,
    type,
    fullWidth,
    customStyle,
    className,
  } = props;
  const customStyleToApply = disabled && customStyle?.disabled 
  ? { ...customStyle, ...customStyle.disabled }
  : customStyle;

  const { colors, borderStyle } = useSafeSelector(
    (state: any) => state.customization
  );
  return (
    <button
      style={{
        opacity: disabled && (colors?.action || customStyleToApply) && '0.4',
        borderRadius:
          borderStyle === 'ROUNDED'
            ? '0.5rem'
            : !borderStyle
            ? 'revert-layer'
            : 0,
        ...customStyleToApply,
        background: id !== 'apple-pay-button' ? (colors?.action || customStyleToApply?.backgroundColor) : '#000',
      }}
      className={[
        styles['container'],
        styles[color || 'primary'],
        fullWidth ? styles['fullWidth'] : '',
        'mt-4',
        ...(className ? [className] : []),
      ].join(' ')}
      onClick={onClick}
      disabled={disabled}
      type={type && type}
      id={id}
    >
      {loading ? (
        <Loader size={16} />
      ) : (
        <>
          {icon && <img src={icon} />}
          {label && (
            <span
              className={`${styles['btn-text']} !border-none`}
              style={{
                ...(customStyleToApply?.['fontSize'] && {
                  fontSize: customStyleToApply['fontSize'],
                }),
                ...(customStyleToApply?.['fontWeight'] && {
                  fontWeight: customStyleToApply['fontWeight'],
                }),
              }}
            >
              {label}
            </span>
          )}
        </>
      )}
    </button>
  );
}
